import React from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import PlayCircleFilledRoundedIcon from "@mui/icons-material/PlayCircleFilledRounded";

// WP-STANDARD | PUBLIC VIDEO COURSE
// STATUS: STATIC_PASS · RUNTIME_PENDING
// Purpose: one canonical, distraction-free learning page. The playlist remains
// the source of truth, so adding/reordering videos in YouTube updates the course
// without requiring a frontend deploy.
const COURSE_PLAYLIST_ID = "PLVzK6TImyCTQ";
const COURSE_EMBED_URL = `https://www.youtube-nocookie.com/embed/videoseries?list=${COURSE_PLAYLIST_ID}&rel=0`;
const COURSE_YOUTUBE_URL = `https://www.youtube.com/playlist?list=${COURSE_PLAYLIST_ID}`;

export default function CourseVideosPage() {
  React.useEffect(() => {
    document.title = "Curso | WebProfit";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        bgcolor: "#0E151D",
        color: "#F7F8FA",
        pt: { xs: 12, sm: 13, md: 14 },
        pb: { xs: 6, md: 9 },
        px: { xs: 2, md: 4 },
      }}
    >
      <Container maxWidth="lg" disableGutters>
        <Stack spacing={{ xs: 2.4, md: 3.2 }}>
          <Box sx={{ maxWidth: 760 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <PlayCircleFilledRoundedIcon sx={{ color: "#F35A3A", fontSize: 30 }} />
              <Typography
                sx={{
                  color: "rgba(255,255,255,.58)",
                  fontWeight: 900,
                  fontSize: ".78rem",
                  letterSpacing: ".11em",
                  textTransform: "uppercase",
                }}
              >
                Curso WebProfit
              </Typography>
            </Stack>

            <Typography
              component="h1"
              sx={{
                mt: 1.1,
                fontWeight: 950,
                letterSpacing: "-.05em",
                lineHeight: 1,
                fontSize: { xs: "2.35rem", sm: "3.2rem", md: "4.2rem" },
              }}
            >
              Todos los videos, en un solo lugar.
            </Typography>

            <Typography
              sx={{
                mt: 1.4,
                maxWidth: 650,
                color: "rgba(255,255,255,.62)",
                lineHeight: 1.65,
                fontSize: { xs: ".96rem", md: "1.06rem" },
              }}
            >
              Seguí la playlist en orden y aplicá cada paso directamente en tu negocio.
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              overflow: "hidden",
              borderRadius: { xs: 3, md: 4.5 },
              bgcolor: "#090E13",
              border: "1px solid rgba(255,255,255,.09)",
              boxShadow: "0 28px 80px rgba(0,0,0,.34)",
            }}
          >
            <Box sx={{ position: "relative", width: "100%", pt: "56.25%" }}>
              <Box
                component="iframe"
                src={COURSE_EMBED_URL}
                title="Curso de WebProfit en YouTube"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
                sx={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            </Box>
          </Paper>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.2}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", sm: "center" }}
          >
            <Typography sx={{ color: "rgba(255,255,255,.45)", fontSize: ".82rem" }}>
              La playlist de YouTube define automáticamente el contenido y el orden del curso.
            </Typography>

            <Button
              href={COURSE_YOUTUBE_URL}
              target="_blank"
              rel="noreferrer"
              endIcon={<OpenInNewRoundedIcon />}
              sx={{
                alignSelf: { xs: "flex-start", sm: "auto" },
                color: "#FF9D84",
                textTransform: "none",
                fontWeight: 900,
                borderRadius: 999,
                px: 1.8,
              }}
            >
              Ver playlist en YouTube
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
